var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Layout', [_c('div', {
    staticClass: "grid-toolbar"
  }, [_c('Button', {
    on: {
      "click": function click($event) {
        _vm.showCreateModal = true;
      }
    }
  }, [_vm._v("新增")]), _c('Button', {
    attrs: {
      "disabled": _vm.selection.length === 0
    },
    on: {
      "click": function click($event) {
        _vm.showUpdateModal = true;
      }
    }
  }, [_vm._v("编辑")]), _c('Button', {
    attrs: {
      "disabled": _vm.selection.length !== 1
    },
    on: {
      "click": _vm.remove
    }
  }, [_vm._v("删除")])], 1), _c('Table', {
    ref: "grid",
    attrs: {
      "border": "",
      "columns": _vm.columns,
      "data": _vm.data,
      "loading": _vm.pageLoading
    },
    on: {
      "on-sort-change": _vm.onSortChange,
      "on-selection-change": _vm.onSelectionChange,
      "on-row-click": _vm.onRowClick
    },
    scopedSlots: _vm._u([{
      key: "btns",
      fn: function fn(_ref) {
        var row = _ref.row;
        return [_c('Button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function click($event) {
              return _vm.viewDetails(row);
            }
          }
        }, [_vm._v("详情")])];
      }
    }])
  }), _c('div', {
    staticClass: "grid-toolbar"
  }, [_c('Page', {
    attrs: {
      "current": _vm.currentPage,
      "total": _vm.total,
      "page-size": _vm.pageSize,
      "show-total": ""
    },
    on: {
      "on-change": _vm.onCurrentPageChange
    }
  }), _c('RadioGroup', {
    staticClass: "page-selector",
    attrs: {
      "type": "button"
    },
    model: {
      value: _vm.pageSize,
      callback: function callback($$v) {
        _vm.pageSize = $$v;
      },
      expression: "pageSize"
    }
  }, _vm._l([10, 25, 50, 100], function (num) {
    return _c('Radio', {
      key: num,
      attrs: {
        "label": num
      }
    }, [_vm._v(_vm._s(num))]);
  }), 1)], 1), _c('GroupModal', {
    attrs: {
      "title": "新增"
    },
    on: {
      "close": _vm.onModalClose
    },
    model: {
      value: _vm.showCreateModal,
      callback: function callback($$v) {
        _vm.showCreateModal = $$v;
      },
      expression: "showCreateModal"
    }
  }), _c('GroupModal', {
    attrs: {
      "title": "编辑",
      "from": "update",
      "group": _vm.selection[0]
    },
    on: {
      "close": _vm.onModalClose
    },
    model: {
      value: _vm.showUpdateModal,
      callback: function callback($$v) {
        _vm.showUpdateModal = $$v;
      },
      expression: "showUpdateModal"
    }
  }), _c('TableDetailModal', {
    attrs: {
      "title": "角色详情",
      "visible": _vm.showTableDetail,
      "data": _vm.tableDetail,
      "columns": _vm.tableDetailColumns
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.showTableDetail = $event;
      }
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };